import _Vue from 'vue'

export type FunctionDeepCopy<T> = (obj: T) => T

export function FunctionsPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$deepCopy = (obj: object): object => {
    return JSON.parse(JSON.stringify(obj))
  }
}
